var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-bar'),_vm._v(" "),_c('b-row',{staticStyle:{"margin":"0px"}},[_c('b-col',{staticStyle:{"padding":"0px"}},[_c('nav-drawer')],1),_vm._v(" "),_c('b-col',{staticStyle:{"padding":"0px"},attrs:{"cols":"10"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d9fce3e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layouts/AdminLayout.vue
// module id = null
// module chunks = 